import { render, staticRenderFns } from "./jmbiotechCustomer.vue?vue&type=template&id=2700ea36&"
import script from "./jmbiotechCustomer.vue?vue&type=script&lang=js&"
export * from "./jmbiotechCustomer.vue?vue&type=script&lang=js&"
import style0 from "./jmbiotechCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports